import { Component, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

export interface FeatureFlagDetailsData {
  teams: any[]
}

@Component({
  selector: 'app-feature-flag-details',
  templateUrl: './feature-flag-details.component.html',
  styleUrls: ['./feature-flag-details.component.css']
})
export class FeatureFlagDetailsComponent {

  constructor(
    public dialogRef: MatDialogRef<FeatureFlagDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FeatureFlagDetailsData) {}

  onClose(): void {
    this.dialogRef.close();
  }

}